import moment from 'moment';
export const formatLimitDate = (v) => v ? moment(v).format('YYYY-MM-DD HH:mm') : '';
export const limitEffectiveToDate = (v) => (v ? new Date(v) : null);
export const limitEffectiveFromDate = (v) => (v ? v.toISOString() : null);
